import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from './providers/ClerkProvider';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);
